import { LowerCasePipe } from '@angular/common';
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import {
  EMicaChat_EstadoMensajeMedia,
  EMicaChat_TipoMensaje,
  MicaChatAudioData,
} from '@core/enums/micachat.enum';
import { MicaChat_MensajesEntity } from '@modules/mica-chat/entities/mensajes.mica-chat';
import { MicaChatMensajeAudio } from '../mica-chat-mensaje-audio/mica-chat-mensaje-audio';
import { MicaChatMensajeImagen } from '../mica-chat-mensaje-imagen/mica-chat-mensaje-imagen';
import { MicaChatMensajeVideo } from '../mica-chat-mensaje-video/mica-chat-mensaje-video';
import { MicaChatMensajeDocumento } from '../mica-chat-mensaje-documento/mica-chat-mensaje-documento';

@Component({
  selector: 'app-mica-chat-mensaje-media',
  imports: [LowerCasePipe, MicaChatMensajeAudio, MicaChatMensajeImagen, MicaChatMensajeVideo, MicaChatMensajeDocumento],
  templateUrl: './mica-chat-mensaje-media.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mica-chat-mensaje-media.css',
})
export class MicaChatMensajeMedia {
  EMicaChat_EstadoMensajeMedia = EMicaChat_EstadoMensajeMedia;
  EMicaChat_TipoMensaje = EMicaChat_TipoMensaje;

  mensaje = input.required<MicaChat_MensajesEntity>();
  esMedia() {
    return Object.values(EMicaChat_TipoMensaje).includes(this.mensaje().tipo) &&
      this.mensaje().tipo !== EMicaChat_TipoMensaje.TEXT
      ? true
      : false;
  }
  estadoMedia = computed(() => {
    if (!this.esMedia()) return EMicaChat_EstadoMensajeMedia.NO_APLICA;
    const payload = this.mensaje().payload;
    if (!payload || typeof payload !== 'object') return EMicaChat_EstadoMensajeMedia.NO_APLICA;
    const mediaPayload = (payload as Record<string, unknown>)[this.mensaje().tipo];
    if (!mediaPayload || typeof mediaPayload !== 'object')
      return EMicaChat_EstadoMensajeMedia.NO_APLICA;
    const status = (mediaPayload as Record<string, unknown>)['status'];
    if (
      status === EMicaChat_EstadoMensajeMedia.DESCARGANDO ||
      status === EMicaChat_EstadoMensajeMedia.DESCARGADO ||
      status === EMicaChat_EstadoMensajeMedia.ERROR_DESCARGA
    ) {
      return status;
    }
    return EMicaChat_EstadoMensajeMedia.NO_APLICA;
  });
  tipoMediaNombre = computed(() => {
    switch (this.mensaje().tipo) {
      case EMicaChat_TipoMensaje.IMAGE:
        return 'Imagen';
      case EMicaChat_TipoMensaje.VIDEO:
        return 'Video';
      case EMicaChat_TipoMensaje.AUDIO:
        return 'Audio';
      case EMicaChat_TipoMensaje.DOCUMENT:
        return 'Documento';
      default:
        return 'Archivo';
    }
  });

  getMediaData(): { stream_url: string | null; caption: string; mime_type: string; file_name: string; id: string } | null {
    const payload = this.mensaje().payload;
    if (!payload || typeof payload !== 'object') return null;
    const mediaPayload = (payload as Record<string, unknown>)[this.mensaje().tipo];
    if (!mediaPayload || typeof mediaPayload !== 'object') return null;
    return {
      stream_url: (typeof (mediaPayload as Record<string, unknown>)['stream_url'] === 'string'
        ? (mediaPayload as Record<string, unknown>)['stream_url']
        : null) as string | null,
      caption: (typeof (mediaPayload as Record<string, unknown>)['caption'] === 'string'
        ? (mediaPayload as Record<string, unknown>)['caption']
        : this.mensaje().texto || '') as string,
      mime_type: (typeof (mediaPayload as Record<string, unknown>)['mime_type'] === 'string'
        ? (mediaPayload as Record<string, unknown>)['mime_type']
        : 'application/octet-stream') as string,
      file_name: (typeof (mediaPayload as Record<string, unknown>)['nombre'] === 'string'
        ? (mediaPayload as Record<string, unknown>)['nombre']
        : typeof (mediaPayload as Record<string, unknown>)['filename'] === 'string'
          ? (mediaPayload as Record<string, unknown>)['filename']
          : 'archivo') as string,
      id: (typeof (mediaPayload as Record<string, unknown>)['id'] === 'string'
        ? (mediaPayload as Record<string, unknown>)['id']
        : '') as string,
    };
  }

  getAudioData(mensaje: MicaChat_MensajesEntity): MicaChatAudioData | null {
    const payload = mensaje.payload;
    if (!payload || typeof payload !== 'object') return null;

    const audioPayload = (payload as Record<string, unknown>)['audio'];
    if (!audioPayload || typeof audioPayload !== 'object') return null;

    const status = (audioPayload as Record<string, unknown>)['status'];
    if (
      status !== EMicaChat_EstadoMensajeMedia.DESCARGANDO &&
      status !== EMicaChat_EstadoMensajeMedia.ERROR_DESCARGA &&
      status !== EMicaChat_EstadoMensajeMedia.DESCARGADO
    ) {
      return null;
    }

    const streamUrl = (audioPayload as Record<string, unknown>)['stream_url'];
    const errorMessage =
      (audioPayload as Record<string, unknown>)['error_message'] ||
      (audioPayload as Record<string, unknown>)['error'];

    return {
      status,
      stream_url: typeof streamUrl === 'string' ? streamUrl : null,
      error_message: typeof errorMessage === 'string' ? errorMessage : null,
    };
  }
}
